import React from 'react';

type SenderType = 'ai' | 'user';
interface IAgentMessageCardProps {
    senderType?: SenderType;
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
}

const AgentMessageCard = ({ senderType, children, className = '', contentClassName = 'p-2' }: IAgentMessageCardProps) => (
    <div className={`max-w-[465px] ${senderType === 'ai' ? 'ai-sender pr-[65px]' : 'pl-[65px] ml-auto user-sender'} ${className}`}>
        <div className={`border border-utilityGray200 rounded-lg space-y-1.5 ${senderType === 'ai' ? 'bg-gray50' : 'bg-utilityIndigo25'} ${contentClassName}`}>{children}</div>
    </div>
);

export default AgentMessageCard;
